import { render } from "./BaseRoomModel.vue?vue&type=template&id=568b1e15"
import script from "./BaseRoomModel.vue?vue&type=script&lang=js"
export * from "./BaseRoomModel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__